document.addEventListener('DOMContentLoaded', function() {
    initializeCartDiscountHandling();
    displayAppliedDiscount(); // Show any already applied discount on page load
    checkCartEmpty();
});

function initializeCartDiscountHandling() {
    const updateCartButton = document.querySelector('.cart__update');
    const discountInput = document.querySelector('.cart__coupon input[name="discount"]');
    const discountField = document.querySelector('.cart__coupon');
    
    // Always show the discount field to ensure it's accessible
    if (discountField) {
        discountField.style.display = 'block';
    }
    
    // Check if there's an applied discount in localStorage and pre-fill the input
    const appliedDiscount = localStorage.getItem('appliedDiscountCode');
    if (appliedDiscount && discountInput) {
        discountInput.value = appliedDiscount;
    }
    
    if (updateCartButton) {
        updateCartButton.addEventListener('click', function(e) {
            e.preventDefault();
            
            const discountCode = discountInput ? discountInput.value.trim() : '';
            
            if (discountCode) {
                updateCartWithDiscount(discountCode);
            } else {
                // No discount code, submit form normally
                const cartForm = document.querySelector('form[action="/cart"]');
                if (cartForm) {
                    cartForm.submit();
                }
            }
        });
    }
}

function updateCartWithDiscount(code) {
    // Show loading state with translated text
    const updateButton = document.querySelector('.cart__update');
    const originalText = updateButton.textContent;
    updateButton.textContent = getTranslation('applying_discount', 'Applying Discount...');
    updateButton.disabled = true;
    
    // Store the discount code in localStorage before applying
    localStorage.setItem('appliedDiscountCode', code);
    
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            discount: code
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        // Restore button state
        updateButton.textContent = originalText;
        updateButton.disabled = false;
        
        if (data.errors) {
            alert(getTranslation('discount_error', 'Discount error: ') + data.errors);
            localStorage.removeItem('appliedDiscountCode'); // Remove invalid code
        } else {
            // Success - reload to see updated prices with language-specific URL
            const languagePrefix = getLanguagePrefix();
            window.location.href = languagePrefix + '/cart';
        }
    })
    .catch(error => {
        console.error('Error:', error);
        // Restore button state
        updateButton.textContent = originalText;
        updateButton.disabled = false;
        alert(getTranslation('apply_error', 'Error applying discount code: ') + error.message);
        localStorage.removeItem('appliedDiscountCode');
    });
}

function displayAppliedDiscount() {
    const appliedDiscount = localStorage.getItem('appliedDiscountCode');
    const discountInput = document.querySelector('.cart__coupon input[name="discount"]');
    const discountField = document.querySelector('.cart__coupon');
    
    if (!appliedDiscount || !discountField) return;
    
    // Create or update the display for applied discount
    let discountDisplay = document.getElementById('appliedDiscountDisplay');
    
    if (!discountDisplay) {
        discountDisplay = document.createElement('div');
        discountDisplay.id = 'appliedDiscountDisplay';
        discountDisplay.className = 'applied-discount-message';
        
        // Insert AFTER the cart__actions div (parent of the coupon section)
        const cartActionsDiv = document.querySelector('.cart__actions');
        if (cartActionsDiv && cartActionsDiv.parentNode) {
            cartActionsDiv.parentNode.insertBefore(discountDisplay, cartActionsDiv.nextSibling);
        }
    }
    
    discountDisplay.innerHTML = `
        <div style="margin-top: 10px; padding: 10px; background: #f8f8f8; border-radius: 4px; border-left: 4px solid #4CAF50;">
            <strong>${getTranslation('applied_discount', 'Applied Discount:')}</strong> ${appliedDiscount}
            <button type="button" id="removeDiscount" style="margin-left: 10px; background: #ff4444; color: white; border: none; padding: 2px 8px; border-radius: 3px; cursor: pointer; font-size: 12px;">
                ${getTranslation('remove_discount', 'Remove')}
            </button>
        </div>
    `;
    
    // Add event listener for remove button
    document.getElementById('removeDiscount').addEventListener('click', function() {
        removeDiscountCode();
    });
    
    // Pre-fill the input with the applied code
    if (discountInput) {
        discountInput.value = appliedDiscount;
        discountInput.disabled = true; // Optional: disable input when code is applied
    }
}

function removeDiscountCode() {
    // Show loading state with translated text
    const updateButton = document.querySelector('.cart__update');
    const originalText = updateButton.textContent;
    updateButton.textContent = getTranslation('removing_discount', 'Removing Discount...');
    updateButton.disabled = true;
    
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            discount: ''
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        // Remove from localStorage
        localStorage.removeItem('appliedDiscountCode');
        
        // Restore button state
        updateButton.textContent = originalText;
        updateButton.disabled = false;
        
        // Reload to see updated prices with language-specific URL
        const languagePrefix = getLanguagePrefix();
        window.location.href = languagePrefix + '/cart';
    })
    .catch(error => {
        console.error('Error:', error);
        // Restore button state
        updateButton.textContent = originalText;
        updateButton.disabled = false;
        alert(getTranslation('remove_error', 'Error removing discount code: ') + error.message);
    });
}

// Also clear discount if cart is emptied
function checkCartEmpty() {
    const cartItems = document.querySelectorAll('[name="updates[]"]');
    if (cartItems.length === 0) {
        localStorage.removeItem('appliedDiscountCode');
    }
}

// Language translation function
function getTranslation(key, fallback) {
    const translations = {
        // English
        'en': {
            'applying_discount': 'Applying Discount...',
            'removing_discount': 'Removing Discount...',
            'applied_discount': 'Applied Discount:',
            'remove_discount': 'Remove',
            'discount_error': 'Discount error: ',
            'apply_error': 'Error applying discount code: ',
            'remove_error': 'Error removing discount code: '
        },
        // Dutch
        'nl': {
            'applying_discount': 'Korting toepassen...',
            'removing_discount': 'Korting verwijderen...',
            'applied_discount': 'Toegepaste korting:',
            'remove_discount': 'Verwijderen',
            'discount_error': 'Kortingsfout: ',
            'apply_error': 'Fout bij toepassen kortingscode: ',
            'remove_error': 'Fout bij verwijderen kortingscode: '
        },
        // German
        'de': {
            'applying_discount': 'Rabatt wird angewendet...',
            'removing_discount': 'Rabatt wird entfernt...',
            'applied_discount': 'Angewendeter Rabatt:',
            'remove_discount': 'Entfernen',
            'discount_error': 'Rabattfehler: ',
            'apply_error': 'Fehler beim Anwenden des Rabattcodes: ',
            'remove_error': 'Fehler beim Entfernen des Rabattcodes: '
        },
        // French
        'fr': {
            'applying_discount': 'Application de la réduction...',
            'removing_discount': 'Suppression de la réduction...',
            'applied_discount': 'Réduction appliquée :',
            'remove_discount': 'Supprimer',
            'discount_error': 'Erreur de réduction : ',
            'apply_error': 'Erreur lors de l\'application du code de réduction : ',
            'remove_error': 'Erreur lors de la suppression du code de réduction : '
        },
        // Spanish
        'es': {
            'applying_discount': 'Aplicando descuento...',
            'removing_discount': 'Eliminando descuento...',
            'applied_discount': 'Descuento aplicado:',
            'remove_discount': 'Eliminar',
            'discount_error': 'Error de descuento: ',
            'apply_error': 'Error al aplicar el código de descuento: ',
            'remove_error': 'Error al eliminar el código de descuento: '
        },
        // Italian
        'it': {
            'applying_discount': 'Applicazione sconto...',
            'removing_discount': 'Rimozione sconto...',
            'applied_discount': 'Sconto applicato:',
            'remove_discount': 'Rimuovi',
            'discount_error': 'Errore sconto: ',
            'apply_error': 'Errore durante l\'applicazione del codice sconto: ',
            'remove_error': 'Errore durante la rimozione del codice sconto: '
        }
    };

    // Get current language from your existing language system
    const currentLanguage = getCurrentLanguage();
    
    // Return translation for current language or fallback
    if (translations[currentLanguage] && translations[currentLanguage][key]) {
        return translations[currentLanguage][key];
    }
    
    return fallback;
}

// Get current language function
function getCurrentLanguage() {
    const path = window.location.pathname;
    if (path.includes('/en/') || path === '/en') return 'en';
    if (path.includes('/de/') || path === '/de') return 'de';
    if (path.includes('/fr/') || path === '/fr') return 'fr';
    if (path.includes('/es/') || path === '/es') return 'es';
    if (path.includes('/it/') || path === '/it') return 'it';
    return 'nl'; // default
}

// Get language prefix for URLs
function getLanguagePrefix() {
    const path = window.location.pathname;
    if (path.includes('/en/') || path === '/en') return '/en';
    if (path.includes('/de/') || path === '/de') return '/de';
    if (path.includes('/fr/') || path === '/fr') return '/fr';
    if (path.includes('/es/') || path === '/es') return '/es';
    if (path.includes('/it/') || path === '/it') return '/it';
    return ''; // nl/default - no prefix
}

// Update discount display when language changes
document.addEventListener('click', (e) => {
    const target = e.target.closest('a');
    if (target && target.href && isLanguageLink(target.href)) {
        // Update discount display after language change
        setTimeout(() => {
            displayAppliedDiscount();
        }, 500);
    }
});

document.addEventListener('change', (e) => {
    if (e.target.matches('select[name="locale"], select[data-language-selector]')) {
        // Update discount display after language change
        setTimeout(() => {
            displayAppliedDiscount();
        }, 500);
    }
});

function isLanguageLink(href) {
    return href.includes('/en') || href.includes('/nl') || 
           href.includes('/fr') || href.includes('/de') ||
           href.includes('/es') || href.includes('/it');
}